
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seja-um-vendedor",
      function () {
        return require("private-next-pages/seja-um-vendedor/index.ts");
      }
    ]);
  